import { Skeleton } from '@hivebrite/design-system/Skeleton';

const BreadcrumbLoader = () => <Skeleton height={30} width={250} />;

export default BreadcrumbLoader;
